export type CityRelation = Readonly<{
  CityCode: string;
  ProvinceId: string;
  CountryCode: string;
}>;

export type ProvincesAndCitiesExternal = Readonly<{
  CitiesRelation: CityRelation[];
  Provinces: string[];
}>;

export type ProvincesByCity = Readonly<{
  ProvinceCode: string;
  ProvinceName: string;
  Cities: CityProvince[];
}>;

export type CityProvince = Readonly<{
  CityCode: string;
  CountryCode: string;
}>;

export enum FilterProvincesBy {
  ProvinceId = 'ProvinceId',
  CityCode = 'CityCode',
  CountryCode = 'CountryCode'
}
